module.exports = __webpack_public_path__ + "img/mobile/Background/landscape_paytable_background@2.25x.jpg?1.1.2";